import React from "react";
import { Link } from "react-router-dom";
import { Button, Box } from "@mui/material";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "95vh",
        width: "100vw",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Button color="inherit" component={Link} to="/about-us">
          About Us
        </Button>
        <Button color="inherit" component={Link} to="/privacy-policy">
          Privacy Policy
        </Button>
        <Button color="inherit" component={Link} to="/terms-of-use">
          Terms of Use
        </Button>
        <Button color="inherit" component={Link} to="/help-and-support">
          Help & Support
        </Button>
      </Box>
    </Box>
    <Footer />
    </>
  );
};

export default Home;
